export const CMAPS = 'CMAPS';
export const GENERIC = 'GENERIC';
export const MMT = 'MMT';
export const ESSENTIAL_IMAGE = 'ESSENTIAL_IMAGE';
export const IALM = 'IALM';
export const VOCU = 'VOCU';
